import { creditAssessment } from "@wayke-se/ecom";
export default (caseId, callback) => {
    creditAssessment
        .decline(caseId)
        .then(callback)
        .catch(() => callback(false));
};
